import Masonry from 'masonry-layout';

document.addEventListener('DOMContentLoaded', function () {
    // ------------------------
    // Masonry Grid Init
    // ------------------------
    const portfolioElement = document.querySelector('.portfolio-grid');
    if (portfolioElement) {
        // Wait for all images to load before initializing Masonry
        const images = portfolioElement.querySelectorAll('img');
        let loadedImages = 0;
        const totalImages = images.length;
        
        if (totalImages === 0) {
            // No images, initialize immediately
            initMasonry();
        } else {
            images.forEach(img => {
                if (img.complete) {
                    imageLoaded();
                } else {
                    img.addEventListener('load', imageLoaded);
                    img.addEventListener('error', imageLoaded);
                }
            });
        }
        
        function imageLoaded() {
            loadedImages++;
            if (loadedImages === totalImages) {
                initMasonry();
            }
        }
        
        function initMasonry() {
            new Masonry(portfolioElement, {
                itemSelector: '.portfolio-grid__item',
                columnWidth: '.portfolio-grid__item',
                percentPosition: true,
                gutter: 10
            });
            // Show grid after Masonry is initialized
            portfolioElement.classList.add('is-ready');
        }
    }

    // ------------------------
    // Single Portfolio Gallery
    // ------------------------
    const singleGallery = document.querySelector('.single-portfolio__gallery--grid');
    if (singleGallery) {
        // Wait for gallery images to load
        const galleryImages = singleGallery.querySelectorAll('img');
        let loadedGalleryImages = 0;
        const totalGalleryImages = galleryImages.length;
        
        if (totalGalleryImages === 0) {
            initGalleryMasonry();
        } else {
            galleryImages.forEach(img => {
                if (img.complete) {
                    galleryImageLoaded();
                } else {
                    img.addEventListener('load', galleryImageLoaded);
                    img.addEventListener('error', galleryImageLoaded);
                }
            });
        }
        
        function galleryImageLoaded() {
            loadedGalleryImages++;
            if (loadedGalleryImages === totalGalleryImages) {
                initGalleryMasonry();
            }
        }
        
        function initGalleryMasonry() {
            new Masonry(singleGallery, {
                itemSelector: '.single-portfolio__gallery--item',
                columnWidth: '.single-portfolio__gallery--item',
                percentPosition: true,
                gutter: 10
            });
            singleGallery.classList.add('is-ready');
        }


const modal = document.getElementById('imageModal');
    const modalImg = modal.querySelector('.image-modal__img');
    const overlay = modal.querySelector('.image-modal__overlay');
    const closeBtn = modal.querySelector('.image-modal__close');

    const galleryItems = document.querySelectorAll('.single-portfolio__gallery--item');
    let currentIndex = 0;

    galleryItems.forEach((link, index) => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            console.log('Opening modal for image');
            currentIndex = index;
            const fullSrc = this.getAttribute('data-full');
            modalImg.src = fullSrc;
            document.body.classList.add('no-scroll');
            modal.classList.add('visible');
        });
    });

    function showImage(index) {
        if (index < 0) index = galleryItems.length - 1;
        if (index >= galleryItems.length) index = 0;
        currentIndex = index;
        const fullSrc = galleryItems[index].getAttribute('data-full');
        modalImg.src = fullSrc;
    }

    document.addEventListener('keydown', e => {
        if (!modal.classList.contains('visible')) return;
        if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
        if (e.key === 'ArrowRight') showImage(currentIndex + 1);
    });

    function closeModal() {
        modal.classList.remove('visible');
        modalImg.src = '';
        document.body.classList.remove('no-scroll');
    }

    overlay.addEventListener('click', closeModal);
    closeBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') closeModal();
    });




    }


    



});
